<template>
    <v-card class="card">
        <v-card-title>
            <span class="message">{{$t('cart.merge-confirmation')}}</span>
        </v-card-title>

        <v-card-actions class="justify-center">
            <v-btn variant="outlined" class="confirm-button" color="blue" @click="mergeDeclined">{{$t('no')}}</v-btn>
            <v-btn variant="outlined" class="confirm-button" color="green" @click="merge">{{$t('yes')}}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script setup lang="ts">
import { useCortonaViewerStore } from '@/stores/cortonaViewer';

const emit = defineEmits<{
  manualMergeDone: [];
}>();

const localCart = () => JSON.parse(localStorage.getItem('cart')) || [];

const loggedInCart = () => {
  const cortonaViewerStore = useCortonaViewerStore();
  return cortonaViewerStore.cartItems;
};

const needsManualMerge = () => localCart().length > 0 && loggedInCart().length > 0;
const needsSimpleMerge = () => localCart().length > 0 && loggedInCart().length === 0;

const mergeDeclined = () => emit('manualMergeDone');

const merge = async () => {
  const cortonaViewerStore = useCortonaViewerStore();
  await cortonaViewerStore.transferLocalCart();
  emit('manualMergeDone');
};
</script>

<style scoped>
.card {
    padding: 1rem;
}

.message {
    word-break: break-word;
}

.confirm-button {
    color: white;
}
</style>